import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import Joyride, { STATUS } from 'react-joyride';

import { UserContext } from '../contexts/user_context';
import { apiCaller } from '../hooks/fetch_hooks';
import { updateUser } from '../utils/api';
import {
  Modal,
  useOutsideAlerter,
} from './modal';

const steps = [
    {
        target: "#profile-avatar",
        disableBeacon: true,
        title: (
            <h6 className="text-left text-k-indigo text-xs pl-2 font-black">
                Manage your profile details
            </h6>
        ),
        content: (
            <p className="text-k11-gray text-sm text-left">
                Update your profiles, change password, verify profile and manage
                other profile here.
            </p>
        ),
    },
    {
        target: "#activity",
        title: (
            <h6 className="text-left text-k-indigo text-xs pl-2 font-black">
                View all transactions on Odio
            </h6>
        ),
        content: (
            <p className="text-k11-gray text-sm text-left">
                View both on-going and completed transactions on your Odio
                account here.
            </p>
        ),
        placement: "right",
    },
    {
        target: "#make-payment",
        title: (
            <h6 className="text-left text-k-indigo text-xs pl-2 font-black">
                Make payments
            </h6>
        ),
        content: (
            <p className="text-k11-gray text-sm text-left">
                Pay for pending or on-going transactions here. Track your
                repayment schedules.
            </p>
        ),
        placement: "right",
    },
    {
        target: "#wallet",
        title: (
            <h6 className="text-left text-k-indigo text-xs pl-2 font-black">
                View your wallet on Odio
            </h6>
        ),
        content: (
            <p className="text-k11-gray text-sm text-left">
                View your balance and wallet payment on Odio. Request for
                Withdrawal of credits here too
            </p>
        ),
        placement: "right",
    },
];

export function Onboarding() {
    const { user, fetchUserDetails } = useContext(UserContext);
    const [run, setRun] = useState(false);
    const ref = useRef();
    const [showModal, setShowModal] = useState(false);
    useOutsideAlerter(ref, () => setShowModal(false));
    useEffect(() => {
        if (user.id && !user.tip) {
            setShowModal(true);
        }
    }, [user]);
    const handleJoyrideCallback = (data) => {
        const { status } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setRun(false);
            apiCaller(() => updateUser({ tip: true }), () => { fetchUserDetails()});
        }
    };
    return (
        <div>
            {showModal && (
                <Modal>
                    <div className="absolute-center">
                        <div
                            ref={ref}
                            className="rounded bg-white p-5 text-k-indigo"
                        >
                            <h6 className="font-bold text-sm text-center">
                                New to Odio
                            </h6>
                            <p className="mt-4 mb-8 text-base text-k11-gray">
                                Let's show you around on how best to navigate on
                                Odio
                            </p>
                            <div className="flex items-center justify-center space-x-6">
                                <button
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                >
                                    Not now
                                </button>
                                <button
                                    onClick={() => {
                                        setRun(true);
                                        setShowModal(false);
                                    }}
                                    className="font-bold"
                                >
                                    OK, Show me
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
            <Joyride
                run={run}
                steps={steps}
                disableOverlayClose={true}
                showSkipButton={false}
                callback={handleJoyrideCallback}
                showProgress={false}
                continuous={true}
                styles={{
                    options: {
                        primaryColor: "#13344d",
                        textColor: "#13344d",
                        zIndex: 10000,
                    },
                }}
                hideBackButton={true}
            />
        </div>
    );
}
